import {isOptionAttribute, OptionAttribute} from "./OptionAttribute";
import TypeCheck from "../../utils/Typecheck";

export interface Option {
    id: number
    price: number
    attributes: Record<string, OptionAttribute>
}

export const isOption = (content: unknown): content is Option => {
    const isAttributes = (attributes: object) => {
        const values = Object.values(attributes);

        return TypeCheck.isArrayOf(values, isOptionAttribute);
    };

    return TypeCheck.isObject(content)
        && TypeCheck.hasAll(content, ['id', 'price', 'attributes'])
        && TypeCheck.isNumber(content.id)
        && TypeCheck.isNumber(content.price)
        && TypeCheck.isObject(content.attributes) && isAttributes(content.attributes);
}

